//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBIpmm0Tnp_8PCVOHUmZ5MlvrsIt5ySjJE",
  authDomain: "cheeseart-d15e8.firebaseapp.com",
  projectId: "cheeseart-d15e8",
  storageBucket: "cheeseart-d15e8.firebasestorage.app",
  messagingSenderId: "1023992588907",
  appId: "1:1023992588907:web:89dd86876e3354c2cddf2e",
  measurementId: "G-VV25GZ87KW",
};

//* Initialize Firebase
let firebase_app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
